export default __webpack_public_path__ + "static/media/icon-close.0f0c47f4.svg";